import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return [];
  }
 
  
  initialize(){

  }

  submit(e){

    Turbolinks.visit(this.element.action + '?' + $(this.element).serialize());
  }
}


// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/submit_on_select_controller.js